import FormInput from '@/components/Form/components/FormInput'
import FormSelector from '@/components/Form/components/FormSelector'
import FormReadOnly from '@/components/Form/components/FormReadOnly'

const applyFormLegalField = [
  {
    label: '企业名称',
    prop: 'enterpriseName',
    component: FormInput,
    isDisabled: () => true,
    componentProps: {
      placeholder: '自动带入不可修改'
    }
  },
  {
    label: '统一社会信用代码',
    prop: 'uniscid',
    component: FormInput,
    isDisabled: () => true,
    componentProps: {
      placeholder: '自动带入不可修改'
    }
  },
  {
    label: '融资经办人姓名',
    prop: 'contactName',
    component: FormInput,
    componentProps: {
      placeholder: '请输入融资经办人姓名'
    }
  },
  {
    label: '融资经办人身份证号',
    prop: 'cardNo',
    component: FormInput,
    componentProps: {
      placeholder: '请输入融资经办人身份证号'
    }
  },
  {
    label: '融资经办人手机号',
    prop: 'contactPhone',
    component: FormInput,
    componentProps: {
      placeholder: '请输入融资经办人手机号'
    }
  }
]

// TODO disabled & isRender
const applyFormPersonField = [
  {
    label: '企业名称',
    prop: 'enterpriseName',
    component: FormInput,
    componentProps: {
      placeholder: '请输入企业名称'
    }
  },
  {
    label: '统一社会信用代码',
    prop: 'uniscid',
    component: FormInput,
    isDisabled: () => true,
    componentProps: {
      placeholder: '自动带入不可修改'
    }
  },
  {
    label: '申请人姓名',
    prop: 'contactName',
    component: FormInput,
    isDisabled: () => true,
    componentProps: {
      placeholder: '请输入申请人姓名'
    }
  },
  {
    label: '申请人手机号',
    prop: 'contactPhone',
    component: FormInput,
    isDisabled: form => !form.uniscid,
    componentProps: {
      placeholder: '请输入申请人手机号'
    }
  },
  {
    label: '申请人与企业关联关系',
    prop: 'applicantEnterpriseRelationship',
    component: FormSelector,
    isDisabled: form => !form.uniscid || form.autoRelationship,
    componentProps: {
      placeholder: '请选择申请人与企业关联关系',
      selectorListName: 'relationshipSelectorList',
      multiple: true,
      onChangeFilter: ids => {
        //   215：其他   与另外选项互斥
        if (ids[ids.length - 1] === '215') {
          ids = ['215']
        } else if (ids.indexOf('215') > -1) {
          ids.splice(ids.indexOf('215'), 1)
        }
        return ids
      }
    }
  },
  {
    label: '是否有共同申请人',
    prop: 'hasJointApplicant',
    component: FormSelector,
    isDisabled: form => !form.uniscid,
    componentProps: {
      placeholder: '请选择',
      selectorListName: 'hasJointApplicantSelectorList'
    }
  },
  {
    label: '共同申请人姓名',
    prop: 'jointApplicantName',
    component: FormInput,
    isDisabled: form => !form.uniscid,
    isRender: form => Number(form.hasJointApplicant) === 1,
    componentProps: {
      placeholder: '请输入共同申请人姓名'
    }
  },
  {
    label: '共同申请人身份证',
    prop: 'jointApplicantCardNo',
    component: FormInput,
    isDisabled: form => !form.uniscid,
    isRender: form => Number(form.hasJointApplicant) === 1,
    componentProps: {
      placeholder: '请输入共同申请人身份证'
    }
  },
  {
    label: '共同申请人手机号',
    prop: 'jointApplicantMobile',
    component: FormInput,
    isDisabled: form => !form.uniscid,
    isRender: form => Number(form.hasJointApplicant) === 1,
    componentProps: {
      placeholder: '请输入共同申请人手机号'
    }
  }
]

const applyFormField = [
  {
    label: '经营地址',
    prop: 'businessLocation',
    component: FormSelector,
    isDisabled: form => form.isPerson && !form.uniscid,
    componentProps: {
      type: 'cascader',
      placeholder: '请选择经营地址',
      selectorListName: 'fullAreaSelectorList'
    }
  },
  {
    //  详细地址
    label: '',
    prop: 'operateArea',
    component: FormInput,
    isDisabled: form => form.isPerson && !form.uniscid,
    componentProps: {
      type: 'textarea',
      placeholder: '请输入详细地址，如街道名称、楼栋号、楼层等'
    }
  },
  {
    label: '融资金额',
    prop: 'applyFinancingAmount',
    component: FormInput,
    isDisabled: form => form.isPerson && !form.uniscid,
    componentProps: {
      placeholder: '请输入融资金额',
      unit: '万元'
    }
  },
  {
    label: '融资期限',
    prop: 'termRange',
    component: FormSelector,
    isDisabled: form => form.isPerson && !form.uniscid,
    componentProps: {
      placeholder: '请选择融资期限',
      selectorListName: 'applyDeadlineSelectorList'
    }
  },
  {
    label: '',
    prop: 'timeLimit',
    component: FormInput,
    isDisabled: form => form.isPerson && !form.uniscid,
    isRender: form => {
      return Number(form.termRange) === -1
    },
    componentProps: {
      placeholder: '请输入融资期限',
      unit: '个月'
    }
  },
  {
    label: '融资类型',
    prop: 'financingCategory',
    component: FormSelector,
    isDisabled: form => form.isPerson && !form.uniscid,
    componentProps: {
      placeholder: '请选择融资类型',
      selectorListName: 'financTypeSelectorList'
    }
  },
  {
    label: '资金用途',
    prop: 'loanUse',
    component: FormInput,
    isDisabled: form => form.isPerson && !form.uniscid,
    componentProps: {
      placeholder: '请输入资金用途'
    }
  },
  {
    label: '担保方式',
    prop: 'guaranteeMeans',
    component: FormSelector,
    isDisabled: form => form.isPerson && !form.uniscid,
    componentProps: {
      placeholder: '请选择担保方式',
      multiple: true,
      selectorListName: 'guaranteeMeansSelectorList'
    }
  }
]

const productFormField = [
  {
    label: '产品名称',
    prop: 'name',
    component: FormReadOnly,
    marginBottom: '5px'
  },
  {
    label: '所属银行',
    prop: 'bankName',
    component: FormReadOnly,
    marginBottom: '12px'
  },
  {
    label: '机构名称',
    prop: 'curSelectedOrg',
    component: FormSelector,
    isDisabled: form => form.isPerson && !form.uniscid,
    componentProps: {
      placeholder: '请选择机构',
      selectorListName: 'branchBankSelectorList'
    },
    marginBottom: '12px'
  },
  {
    label: '贷款额度',
    prop: 'quotaRangeEnd',
    component: FormReadOnly,
    marginBottom: '5px'
  },
  {
    label: '资金用途',
    prop: 'loanUse',
    component: FormReadOnly,
    marginBottom: '5px'
  },
  {
    label: '期限范围',
    prop: 'termRange',
    component: FormReadOnly,
    marginBottom: '5px'
  },
  {
    label: '年息范围',
    prop: 'annualInterestRange',
    component: FormReadOnly,
    marginBottom: '5px'
  },
  {
    label: '审批时间',
    prop: 'acceptanceTime',
    component: FormReadOnly,
    marginBottom: '5px'
  },
  {
    label: '担保方式',
    prop: 'guaranteeMeans',
    component: FormReadOnly,
    marginBottom: '5px'
  },
  {
    label: '还款方式',
    prop: 'repaymentMeans',
    component: FormReadOnly,
    marginBottom: '5px'
  },
  {
    label: '融资类型',
    prop: 'financingCategory',
    component: FormReadOnly,
    marginBottom: '5px'
  }
]

export { applyFormLegalField, applyFormPersonField, applyFormField, productFormField }
